import {ShareRegistrationLinkSheet as SharedSheet} from '@chekin/shared/guest-form';
import {useSummary} from 'context/summary';
import {useRegistrationShareLink} from 'hooks/useRegistrationShareLink';

type Props = {
  open: boolean;
  onClose: () => void;
};

function ShareRegistrationLinkSheet({open, onClose}: Props) {
  const {housingName} = useSummary();
  const link = useRegistrationShareLink();

  return (
    <SharedSheet open={open} onClose={onClose} housingName={housingName} link={link} />
  );
}

export {ShareRegistrationLinkSheet};
